import { createFileRoute, redirect } from '@tanstack/react-router';
import { NewReadingFlow } from '../../../features/silo-counts/components/NewReadingFlow';

export interface NewReadingSearch {
  locationId?: string;
  readingId?: string;
}

/** Guided silo-reading flow (BUILD_SPEC.md §8.2, plan.md G22). Accepts optional
 * `?locationId=` (deep-linked from the silo status overview's "tap to read"
 * cards) and `?readingId=` (resume an existing DRAFT reading from the readings
 * register instead of starting a fresh one).
 *
 * `beforeLoad` guard (Stuart ruling 2026-08-26: silos default OFF per tenant)
 * — same `context.auth`-based redirect as status.tsx; see that file's comment
 * for why `beforeLoad` (not a render-time redirect) was chosen here. */
export const Route = createFileRoute('/_authenticated/silo-counts/new-reading')({
  beforeLoad: ({ context }) => {
    if (context.auth.activeTenant?.settings.silosEnabled !== true) {
      throw redirect({ to: '/silo-counts/counts' });
    }
  },
  validateSearch: (search: Record<string, unknown>): NewReadingSearch => ({
    locationId: typeof search.locationId === 'string' ? search.locationId : undefined,
    readingId: typeof search.readingId === 'string' ? search.readingId : undefined,
  }),
  component: NewReadingRoute,
});

function NewReadingRoute() {
  const { locationId, readingId } = Route.useSearch();
  return <NewReadingFlow initialLocationId={locationId} initialReadingId={readingId} />;
}
